import type {
  CountryDefaultArgs,
  CountryGetPayload,
  CountrySubdivisionDefaultArgs,
  CountrySubdivisionGetPayload,
  RegionDefaultArgs,
  RegionGetPayload,
} from '@repo/database/src/types';

// Region with relations

export const regionWithIncludes = {
  include: {
    countries: {
      include: {
        country: true,
      },
    },
    subdivisions: {
      include: {
        subdivision: {
          include: {
            country: true,
          },
        },
      },
    },
    agentDeals: {
      where: {
        deletedAt: null,
      },
      include: {
        user: {
          select: {
            id: true,
            alias: true,
            firstName: true,
            lastName: true,
          },
        },
      },
    },
  },
} satisfies RegionDefaultArgs;

// Country with relations
export const countryWithIncludes = {
  include: {
    regions: {
      include: {
        region: true,
      },
    },
    subdivisions: true,
  },
} satisfies CountryDefaultArgs;

// CountrySubdivision with relations
export const countrySubdivisionWithIncludes = {
  include: {
    country: true,
    regions: {
      include: {
        region: true,
      },
    },
  },
} satisfies CountrySubdivisionDefaultArgs;

// Export the types
export type RegionDto = RegionGetPayload<typeof regionWithIncludes>;
export type CountryDto = CountryGetPayload<typeof countryWithIncludes>;
export type CountrySubdivisionDto = CountrySubdivisionGetPayload<typeof countrySubdivisionWithIncludes>;
